"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypeSpecCompileError = void 0;
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const localizeUtils_1 = require("../../../../common/localizeUtils");
const errorCode = "TypeSpecCompileError";
const messageKey = "driver.typespec.error.compileError";
class TypeSpecCompileError extends teamsfx_api_1.UserError {
    constructor(actionName, output) {
        super({
            source: actionName,
            name: errorCode,
            message: (0, localizeUtils_1.getDefaultString)(messageKey, output),
            displayMessage: (0, localizeUtils_1.getLocalizedString)(messageKey, output),
        });
    }
}
exports.TypeSpecCompileError = TypeSpecCompileError;
//# sourceMappingURL=typeSpecCompileError.js.map